import { z } from 'zod';
import { AddressSchema } from './property.js';

export const TaskStatusSchema = z.enum([
  'AVAILABLE',
  'ASSIGNED',
  'IN_PROGRESS',
  'COMPLETED',
  'CANCELLED',
]);
export type TaskStatus = z.infer<typeof TaskStatusSchema>;

export const TaskTypeSchema = z.enum(['LAND_MONITORING', 'REVIEW']);
export type TaskType = z.infer<typeof TaskTypeSchema>;

export const TaskSchema = z.object({
  id: z.string(),
  type: TaskTypeSchema,
  createdAt: z.string(),
  title: z.string(),
  location: AddressSchema,
  entityId: z.string(),
  after: z.string(),
  before: z.string(),
  completed: z.string().optional(),
  status: TaskStatusSchema,
  assignedTo: z.string().optional(),
  artifactId: z.string().optional(),
  ownerName: z.string().optional(),
});
export type Task = z.infer<typeof TaskSchema>;
